import { render, staticRenderFns } from "./PaymentStatus.vue?vue&type=template&id=389cf22b&scoped=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=js"
export * from "./PaymentStatus.vue?vue&type=script&lang=js"
import style0 from "./PaymentStatus.vue?vue&type=style&index=0&id=389cf22b&prod&lang=scss&scoped=true"
import style1 from "./PaymentStatus.vue?vue&type=style&index=1&id=389cf22b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389cf22b",
  null
  
)

export default component.exports